(() => {
  const LIMIT = 20;
  const BASE_URL = `https://www.fpapplications.com/v2/collections?currency=${CURRENCY_CODE}&id=${window.collection_id}&limit=${LIMIT}`;
  const fetchUrl = buildFetchFromParams();
  window.COLLECTION_PROMISE = fetch(fetchUrl);

  function getParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(urlSearchParams.entries());
    const page = queryParams.page ? queryParams.page : 1;
    const filters = queryParams.tags ? queryParams.tags : '';
    const vendors = queryParams.vendor ? queryParams.vendor : '';
    const price = queryParams.price ? queryParams.price : '';
    const rating = queryParams.review_rating ? queryParams.review_rating : '';
    const sort = queryParams.order_by ? queryParams.order_by : '';

    return {
      page,
      filters,
      vendors,
      price,
      rating,
      sort,
    };
  }

  function buildFetchFromParams() {
    return buildFetchUrl({
      include_filters: true,
      params: getParams(),
    });
  }

  function buildFetchUrl(
    { include_filters = false, params: { page = 1, filters, vendors, price, rating, sort, append_results } } = {
      params: {},
    }
  ) {
    const params = `page=${page}${filters ? `&tags=${filters}` : ''}${vendors ? `&vendor=${vendors}` : ''}${
      price ? `&price=${price}` : ''
    }${rating ? `&review_rating=${rating}` : ''}${sort ? `&order_by=${sort}` : ''}${
      append_results ? '&append_results=true' : ''
    }`;
    const currentFetchUrl = `${BASE_URL}${include_filters ? '&include_filters=true' : ''}&${params}`;
    window.history.pushState(null, '', `?${params}`);

    return currentFetchUrl;
  }
})();
